// Session timeout durations in milliseconds
export const SESSION_TIMEOUT_CONFIG = {
    // Time before showing warning (in milliseconds)
    WARNING_TIME: 58 * 60 * 1000,
    // Total time before logout (in milliseconds)  
    LOGOUT_TIME: 59 * 60 * 1000,
    // Production values (commented out for reference)
    // WARNING_TIME: 25 * 60 * 1000, // 25 minutes
    // LOGOUT_TIME: 30 * 60 * 1000, // 30 minutes
    // Minimum time between session extension requests (throttle)
    SESSION_EXTENSION_THROTTLE: 1 * 60 * 1000,
    // Time to show warning before logout
    get WARNING_DURATION () {
        return this.LOGOUT_TIME - this.WARNING_TIME;
    },
    // Events to track for user activity (used only for throttled session extension)
    ACTIVITY_EVENTS: [
        'mousedown',
        'keypress',
        'click'
    ]
};
